<template>
    <div style="height: 100%">
        <Table :totalSize="pages.total" style="width: 100%;" :pagination="true" :operationWidth="350"
            :currentPage="pages.current" :pageSize="pages.size" navHeight=40 ref="table" :tableData="tableData"
            @changeCurrentPage="changeCurrentPage" @changePageSize="changePageSize"
            :tableKey="tableKey">
            <template slot="operation" slot-scope="data">
                <div class="btn-button disable-button" v-if="['0','2','3'].includes(data.data.row.examineStatus)&&isTimeArea(data.data.row.beginTime, data.data.row.endTime)">开始任务</div>
                    <div class="btn-button" v-else-if="['1', null].includes(data.data.row.examineStatus)&&isTimeArea(data.data.row.beginTime, data.data.row.endTime)"
                        @click="startTask(data.data.row)">开始任务</div>
                    <div class="btn-button" v-else-if="!isTimeArea(data.data.row.beginTime, data.data.row.endTime)"
                        @click="viewScoreDetail(data.data.row)">查看详情</div>
            </template>
            <template slot="examineStatus" slot-scope="data">
                <div class="label-status"
                            :style="`background-color:${filterTaskStatus(data.data.row.examineStatus).color};`">{{
                                filterTaskStatus(data.data.row.examineStatus).label }}</div>
            </template>
        </Table>
        <theory-detail :detail="detail" ref="theory_detail"></theory-detail>
    </div>
</template>

<script>
import { isTimeArea } from '@/utils/utils';
import { filterTaskStatus } from '@/utils/utils';
import { GetTestPaperQuestion, GetUserAnswerRecord } from '@/api/paper';
import { PageExamineStd, GetExaminePaperId } from '@/api/examine';
import TheoryDetail from './TheoryDetail.vue';
export default {
  props:['name','examineStatus'],
  components: { TheoryDetail },
    data() {
        return {
            tableKey: [
                {
                    name: '考核名称',
                    value: 'examineName',
                },
                {
                    name: '考核状态',
                    value: 'examineStatus',
                    slot:'examineStatus'
                },
                {
                    name: '开始时间',
                    value: 'beginTime'
                },
                {
                    name: '结束时间',
                    value: 'endTime'
                },
                {
                    name: '',
                    value: 'operation',
                    slot: 'operation'
                },
            ],
            pages: {
                current: 1,
                size: 10,
                total: 0
            },
            tableData: [],
            paperId:'',
            detail:{},
        }
    },
    methods: {
        isTimeArea,
        filterTaskStatus,
        viewScoreDetail(data) {
            this.getExaminePaperId(data.id).then((paperId) => {
                    this.paperId = paperId;
                    this.getUserAnswerRecord(data.id);
                })
        },
         /**获取用户答题记录 */
         getUserAnswerRecord(examineId) {
            return new Promise(resolve => {
                var params = {
                    "businessId": examineId + '-' + this.paperId,
                    "testPaperId": this.paperId,
                    "testPaperSource": 'examine_paper'
                }
                GetUserAnswerRecord(params).then(async (res) => {
                    if (res.code == 200) {
                        this.recordId = res.data.id;
                        await this.getTestPaperQuestion(examineId);
                        this.$set(this.detail, 'userQuestionScoreVOS', res.data.userQuestionScoreVOS);
                        let startTime = new Date(res.data.startTime).getTime();
                        let endTime = new Date(res.data.endTime).getTime();
                        let userTestTime = (endTime - startTime) / 1000;
                        this.$set(this.detail, 'userTestTime', userTestTime);
                        let questionDetailVOS = this.detail.questionDetailVOS;
                        res.data.userQuestionScoreVOS && res.data.userQuestionScoreVOS.forEach(item => {
                            var data = questionDetailVOS[item.questionType];
                            var userAnswer = item.userAnswer || [];
                            if (data) {
                                let e = data.find(el => el.questionId == item.questionId);
                                if (e) {
                                    this.$set(e, 'correctAnswer', item.correctAnswer || []);
                                    this.$set(e, 'score', item.score || 0);
                                    this.$set(e, 'content', item.content || '暂无');
                                    var questionType = item.questionType;
                                    if (questionType == '多选题') {
                                        e.value = userAnswer;
                                    } else if (questionType == '填空题') {
                                        e.questionOptionVOS.forEach((a, b) => {
                                            a.value = userAnswer[b] ? userAnswer[b] : '';
                                        })
                                    } else {
                                        e.value = userAnswer[0] ? userAnswer[0] : '';
                                    }
                                }
                            }
                        })
                        resolve(res.data);
                    }
                })
            })
        },
        /**获取试卷题目数据 */
        getTestPaperQuestion(examineId) {
            return new Promise(resolve => {
                var params = {
                    "businessId": examineId + '-' + this.paperId,
                    "testPaperId": this.paperId,
                    "testPaperRecordId": this.recordId
                }
                GetTestPaperQuestion(params).then(res => {
                    if (res.code == 200) {
                        var questionDetailVOS = res.data.questionDetailVOS;
                        var i = 1;
                        for (let key in questionDetailVOS) {
                            questionDetailVOS[key].orderIndex = i;
                            i++;
                            questionDetailVOS[key] && questionDetailVOS[key].forEach(item => {
                                if (key == '多选题') {
                                    item.value = [];
                                    return;
                                } else if (key == '填空题') {
                                    item.questionOptionVOS && item.questionOptionVOS.forEach(el => {
                                        el.value = '';
                                    })
                                } else {
                                    item.value = '';
                                }
                            })
                        }
                        this.detail = res.data;
                        let dialog = this.$refs.theory_detail;
                        if (dialog) {
                            dialog.dialogVisible = true;
                        }
                        resolve(res.data);
                    }
                })
            })
        },
        pageExamineStd() {
            let params = {
                "current": this.pages.current,
                "examineName": this.name,
                "examineStatus": this.examineStatus,
                "examineType": '0',
                "size": this.pages.size
            };
            PageExamineStd(params).then(res => {
                if (res.code == 200) {
                   this.tableData=res.data.records;
                   this.pages.total=res.data.total;
                }
            })
        },
        changeCurrentPage(e){
            this.pages.current=e;
            this.pageExamineStd();
        },
        changePageSize(e){
            this.pages.size=e;
            this.search();
        },
        startTask(data){
            this.getExaminePaperId(data.id).then((paperId) => {
                    var href = window.location.origin + `/theoryTest?id=${paperId}&examineId=${data.id}`;
                    window.open(href, '_blank');
                })
        },
         /**通过考核id获取理论试卷(组合) */
         getExaminePaperId(id) {
            return new Promise((resolve) => {
                GetExaminePaperId({ id }).then(res => {
                    if (res.code == 200) {
                        resolve(res.data);
                    }
                })
            })
        },
        /**模糊查询 */
        search() {
            this.pages.current = 1;
            this.pageExamineStd();
        },
    },
    watch: {
        examineStatus() {
            this.search();
        },
    },
    mounted(){
        this.search();
    }
}
</script>

<style lang="less" scoped>
.btn-button {
    width: 72px;
    height: 25px;
    color: #ffffff;
    background-color: var(--blue);
    border-radius: 0.6rem;
    display: flex;
    font-size: 14px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.disable-button {
    cursor: not-allowed !important;
    background-color: #C0C4CC !important;
}
.label-status {
    padding: 0.2rem 0.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.4rem 0px 0.4rem 0px;
    color: #ffffff;
}
/deep/.table{
    height: calc(100% - 7.2rem);
}
</style>